<template>
  <div id="top">
    <div id="top-about" class="about" :style="about_bgStyle">
      <h2><img :src="`${publicPath}img/top/about_title.png`" alt="天才たちとの恋愛頭脳GAME -公式からの無理難題-"></h2>
      <div class="ar1"><img :src="`${publicPath}img/top/about_ar1_txt.png`" alt=""></div>
      <div class="ar2">
        <h3><img :src="`${publicPath}img/top/about_ar2_tit.png`" alt="ものがたり"></h3>
        <div class="chara"><img :src="`${publicPath}img/top/about_ar2_chara.gif`" alt=""></div>
        <div class="txt"><img :src="`${publicPath}img/top/about_ar2_txt.png`" alt=""></div>
      </div>
      <div class="ar3">
        <h3><img :src="`${publicPath}img/top/about_ar3_tit.png`" alt="遊び方"></h3>
        <div class="chara">
          <div class="chara1"><img :src="`${publicPath}img/top/about_ar3_chara1.gif`" alt=""></div>
          <div class="chara2"><img :src="`${publicPath}img/top/about_ar3_chara2.gif`" alt=""></div>
        </div>
        <div class="txt"><img :src="`${publicPath}img/top/about_ar3_txt.png`" alt=""></div>
      </div>
    </div>
    <div id="top-select" class="select list">
      <h2><img :src="`${publicPath}img/top/chara_title.png`" alt="CHARACTER SELECT"></h2>
      <div class="lv lv1">
        <h3><img :src="`${publicPath}img/top/chara_lv1_tit.png`" alt="初級"></h3>
        <ul>
          <li @click="onSelectChara('shirogane')">
            <img :src="`${publicPath}img/top/chara_shirogane.png`" alt="">
            <p>白銀御行</p>
          </li>
          <li @click="onSelectChara('iino')">
            <img :src="`${publicPath}img/top/chara_iino.png`" alt="">
            <p>伊井野ミコ</p>
          </li>
        </ul>
      </div>
      <div class="lv lv2">
        <h3><img :src="`${publicPath}img/top/chara_lv2_tit.png`" alt="中級"></h3>
        <ul>
          <li @click="onSelectChara('kaguya')">
            <img :src="`${publicPath}img/top/chara_kaguya.png`" alt="">
            <p>四宮かぐや</p>
          </li>
          <li @click="onSelectChara('ishigami')">
            <img :src="`${publicPath}img/top/chara_ishigami.png`" alt="">
            <p>石上優</p>
          </li>
        </ul>
      </div>
      <div class="lv lv3">
        <h3><img :src="`${publicPath}img/top/chara_lv3_tit.png`" alt="上級"></h3>
        <ul>
          <li @click="onSelectChara('tsubame')">
            <img :src="`${publicPath}img/top/chara_tsubame.png`" alt="">
            <p>子安つばめ</p>
          </li>
          <li @click="onSelectChara('hayasaka')">
            <img :src="`${publicPath}img/top/chara_hayasaka.png`" alt="">
            <p>早坂愛</p>
          </li>
        </ul>
      </div>
      <div class="lv lv4">
        <h3><img :src="`${publicPath}img/top/chara_lv4_tit.png`" alt="難題美女？"></h3>
        <ul>
          <li @click="onSelectChara('fujiwara')">
            <img v-if="this.allClearState===false" :src="`${publicPath}img/top/chara_secret.png`" alt="">
            <img v-if="this.allClearState===true" :src="`${publicPath}img/top/chara_fujiwara.png`" alt="">
            <p v-if="this.allClearState===false">? ? ?</p>
            <p v-if="this.allClearState===true">藤原千花</p>
          </li>
        </ul>
      </div>
      <div class="hr_arw" :style="hr_arwStyle"></div>
    </div>
    <div id="top-trial" class="trial list">
      <div class="chara"><img :src="`${publicPath}img/top/trial_chara.gif`" alt=""></div>
      <h2><img :src="`${publicPath}img/top/trial_title.png`" alt="攻略本を読む -無料試し読み-"></h2>
      <div class="lv">
        <h3><img :src="`${publicPath}img/top/trial_shirogane_tit.png`" alt="初級 白銀の攻略本"></h3>
        <ul>
          <li @click="onSelectTrial('shirogane_01')">
            <img :src="`${publicPath}img/top/trial_q1.png`" alt="第1問を読む">
          </li>
          <li @click="onSelectTrial('shirogane_02')">
            <img :src="`${publicPath}img/top/trial_q2.png`" alt="第2問を読む">
          </li>
          <li @click="onSelectTrial('shirogane_03')">
            <img :src="`${publicPath}img/top/trial_q3.png`" alt="第3問を読む">
          </li>
          <li @click="onSelectTrial('shirogane_04')">
            <img :src="`${publicPath}img/top/trial_q4.png`" alt="第4問を読む">
          </li>
        </ul>
      </div>
      <div class="lv">
        <h3><img :src="`${publicPath}img/top/trial_iino_tit.png`" alt="初級 伊井野の攻略本"></h3>
        <ul>
          <li @click="onSelectTrial('iino_01')">
            <img :src="`${publicPath}img/top/trial_q1.png`" alt="第1問を読む">
          </li>
          <li @click="onSelectTrial('iino_02')">
            <img :src="`${publicPath}img/top/trial_q2.png`" alt="第2問を読む">
          </li>
          <li @click="onSelectTrial('iino_03')">
            <img :src="`${publicPath}img/top/trial_q3.png`" alt="第3問を読む">
          </li>
          <li @click="onSelectTrial('iino_04')">
            <img :src="`${publicPath}img/top/trial_q4.png`" alt="第4問を読む">
          </li>
        </ul>
      </div>
      <div class="lv">
        <h3><img :src="`${publicPath}img/top/trial_kaguya_tit.png`" alt="中級 かぐやの攻略本"></h3>
        <ul>
          <li @click="onSelectTrial('kaguya_01')">
            <img :src="`${publicPath}img/top/trial_q1.png`" alt="第1問を読む">
          </li>
          <li @click="onSelectTrial('kaguya_02')">
            <img :src="`${publicPath}img/top/trial_q2.png`" alt="第2問を読む">
          </li>
          <li @click="onSelectTrial('kaguya_03')">
            <img :src="`${publicPath}img/top/trial_q3.png`" alt="第3問を読む">
          </li>
          <li @click="onSelectTrial('kaguya_04')">
            <img :src="`${publicPath}img/top/trial_q4.png`" alt="第4問を読む">
          </li>
        </ul>
      </div>
      <div class="lv">
        <h3><img :src="`${publicPath}img/top/trial_ishigami_tit.png`" alt="中級 石上の攻略本"></h3>
        <ul>
          <li @click="onSelectTrial('ishigami_01')">
            <img :src="`${publicPath}img/top/trial_q1.png`" alt="第1問を読む">
          </li>
          <li @click="onSelectTrial('ishigami_02')">
            <img :src="`${publicPath}img/top/trial_q2.png`" alt="第2問を読む">
          </li>
          <li @click="onSelectTrial('ishigami_03')">
            <img :src="`${publicPath}img/top/trial_q3n4.png`" alt="第3&amp;4問を読む">
          </li>
        </ul>
      </div>
      <div class="lv">
        <h3><img :src="`${publicPath}img/top/trial_hayasaka_tit.png`" alt="上級 早坂の攻略本"></h3>
        <ul>
          <li @click="onSelectTrial('hayasaka_01')">
            <img :src="`${publicPath}img/top/trial_q5.png`" alt="第5問を読む">
          </li>
        </ul>
      </div>
      <div class="lv">
        <h3><img :src="`${publicPath}img/top/trial_tsubame_tit.png`" alt="上級 つばめの攻略本"></h3>
        <ul>
          <li @click="onSelectTrial('tsubame_01')">
            <img :src="`${publicPath}img/top/trial_q3.png`" alt="第3問を読む">
          </li>
        </ul>
      </div>
      <div class="hr_arw" :style="hr_arwStyle"></div>
    </div>
    <div id="top-sns" class="sns">
      <div class="chara">
        <div class="img"><img :src="`${publicPath}img/top/sns_chara.gif`" alt=""></div>
      </div>
      <h2><img :src="`${publicPath}img/top/sns_title.png`" alt="このゲームをシェアする"></h2>
      <ul>
        <li><a :href="share_TW" rel="nofollow" target="_blank" ><img :src="`${publicPath}img/top/sns_tw.png`" alt="Twitter"></a></li>
        <li><a :href="share_FB" rel="nofollow" target="_blank"><img :src="`${publicPath}img/top/sns_fb.png`" alt="Facebook" ></a></li>
        <li><a :href="share_LINE" rel="nofollow" target="_blank" ><img :src="`${publicPath}img/top/sns_line.png`" alt="LINE"></a></li>
      </ul>
    </div>
    <div id="top-secret" class="secret">
      <div class="chara1" @click="onSelectChara('shijo')"><img :src="`${publicPath}img/top/secret_chara1.png`" alt=""></div>
      <div class="chara2" @click="onSelectChara('shijo')"><img :src="`${publicPath}img/top/secret_chara2.png`" alt=""></div>
      <div class="chara3"><img :src="`${publicPath}img/top/secret_chara3.png`" alt=""></div>
    </div>
    <div id="comic">
      <h2><img :src="`${publicPath}img/top/comic_title.png`" alt="最新刊"></h2>
      <div class="img"><a href="https://www.s-manga.net/items/contents.html?isbn=978-4-08-891870-9" target="_blank"><img :src="`${publicPath}img/top/comic_img.png`" alt="22巻"></a></div>
      <div class="txt"><img :src="`${publicPath}img/top/comic_txt.png`" alt="かぐや様は告らせたい 第22巻 好評発売中"></div>
    </div>
    <div class="copyright">&copy;赤坂アカ／集英社 Copyright &copy; SHUEISHA Inc. All rights reserved.</div>
  </div>
</template>

<script>
  import _$ from 'jquery'
  // import _ from 'lodash'

  export default {
    name: 'Story',
    components: {
    },
    props: {
      storyData: Object
    },
    data(){
      return {
        publicPath: process.env.BASE_URL,
        mv_bgStyle: {
          backgroundImage: 'url(./img/top/top_checkline.png), url(./img/top/top_checkline.png)'
        },
        about_bgStyle: {
          backgroundImage: 'url(./img/top/top_checkline.png), url(./img/top/top_checkline.png), url(./img/top/top_checkline.png), url(./img/top/top_checkline.png)'
        },
        hr_arwStyle: {
          backgroundImage: 'url(./img/top/hr_arw.png)'
        },
        allClearState: false,
        timer_fujiwara: null,
        timer_iino: null,
        timer_shijo: null,

        share_FB: null,
        share_LINE: null,
        share_TW: null
      }
    },
    deforeCreate() {
    },
    // created() {
    //   this.sendProgress();
    // },
    // beforeMount() {
    //   this.sendProgress();
    // },
    mounted() {
      // this.sendProgress();
      let startState = this.$parent.storageData.startState.val
      if(startState === 'top_fr_trial'){
        this.smoothScroll('top-select')

        this.$parent.storageData.startState.val = null
        this.$parent.setLocalStorage()
      }

      // クリアcheck
      let clearStateObj = this.$parent.storageData.clearState
      let clearCountNum = 0

      if(clearStateObj){
        Object.keys(clearStateObj).forEach(function(key) {
          if(clearStateObj[key] === true){
            let listNum = null,
                level = null
            switch(key){
              case 'shirogane':
                level = 'lv1'
                listNum = 0
                break
              case 'iino':
                level = 'lv1'
                listNum = 1
                break
              case 'kaguya':
                level = 'lv2'
                listNum = 0
                break
              case 'ishigami':
                level = 'lv2'
                listNum = 1
                break
              case 'tsubame':
                level = 'lv3'
                listNum = 0
                break
              case 'hayasaka':
                level = 'lv3'
                listNum = 1
                break
              case 'fujiwara':
                level = 'lv4'
                listNum = 0
            }

            if(listNum !== null){
              _$('#top-select .' + level + ' ul li').eq(listNum).addClass('clear')
            }

            // 藤原オープンcheck
            if(key !== 'fujiwara' && key !== 'shijo'){
              clearCountNum++
            }
          }
        })
        if(clearCountNum === Object.keys(clearStateObj).length - 2){
          this.allClearState = true
        }
      }

      this.triggerAct()

      // console.log("### allClearState", this.allClearState, clearCountNum)

      // シェア文言
      let shareURL = 'https://youngjump.jp/kaguyasama/zunougame/',
          tweetVal = '『 #かぐや様は告らせたい 』への愛が試される #天才たちとの恋愛頭脳GAME 公開中！\n'
                   + 'キャラの性格を理解して、天才たちに告らせられるか！？\n'
                   + 'ゲームをクリアして、限定ドット絵壁紙をGET！'

      this.share_FB = 'http://www.facebook.com/share.php?u=' + shareURL
      this.share_LINE = 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(shareURL)
      this.share_TW = 'https://twitter.com/share?url=' + shareURL + '&text=' + encodeURIComponent(tweetVal)
    },
    destroyed () {
      clearInterval(this.timer_fujiwara)
      clearInterval(this.timer_iino)
      clearInterval(this.timer_shijo)
    },
    watch: {
    },
    computed: {

    },
    methods: {
      onSelectChara(val){
        switch(true){
          case val !== 'fujiwara':
          case val === 'fujiwara' && this.allClearState === true:
            this.$emit('selectChara', val);
        }

        // **** ↓ 製作用（藤原常時オープン）↓ *****
        // this.$emit('selectChara', val);
        // ************************************
      },
      onSelectTrial(val){
        let chara = val.substring(0, val.indexOf('_')),
            num = val.substr(val.indexOf('_') + 1, 2),
            url = './trial/' + chara + '/' + num + '/'
            
        window.location.href = url
        this.$parent.saveStartPos(chara, 0)
      },
      smoothScroll(id){
        let position = document.getElementById(id).offsetTop;
        if(position < 0){
          position = 0;
        }
        _$("html, body").animate({scrollTop: position}, 1, 'swing');
      },
      triggerAct(){
        let winH = _$(window).height(),
            _$iino = _$('#top .about .ar3 .chara .chara2'),
            _$fujiwara = _$('#top .sns .chara .img'),
            _$shijo1 = _$('#top .secret .chara1'),
            _this = this

        _$(window).scroll(function(){
          let scroll_top = _$(this).scrollTop(),
              triggerPos = scroll_top + winH

          if(triggerPos > _$iino.offset().top && !_$iino.hasClass('show')){
              _$iino.addClass('show')
              _this.anim_iino()
          }

          if(triggerPos > _$fujiwara.offset().top && !_$fujiwara.hasClass('show')){
              _$fujiwara.addClass('show')
              _this.anim_fujiwara()
          }

          if(triggerPos > _$shijo1.offset().top && !_$shijo1.hasClass('show')){
              _$shijo1.addClass('show')
              _this.anim_shijo()
          }
        })
      },
      anim_fujiwara(){
        let _$fujiwara = _$('#top .sns .chara .img'),
            movNum = 0

        this.timer_fujiwara = setInterval(function(){
          if(movNum > 140){
            movNum = 0
          }
          movNum += 4
          _$fujiwara.css({
            transform: 'translateX(' + movNum * -1 + 'vw)'
          })
        }.bind(this), 600)
      },
      anim_iino(){
        let _$iino = _$('#top .about .ar3 .chara .chara2'),
            movNum = 0

        this.timer_iino = setInterval(function(){
          if(movNum <= 30){
            movNum += 4
          } else {
            clearInterval(this.timer_iino)
          }
          _$iino.css({
            transform: 'translateX(' + movNum * -1 + 'vw)'
          })
        }.bind(this), 400)
      },
      anim_shijo(){
        let _$shijo1 = _$('#top .secret .chara1'),
            _$shijo2 = _$('#top .secret .chara2'),
            _$shijo3 = _$('#top .secret .chara3'),
            movNum1 = 0,
            movNum2 = 0,
            countNum = 0

        this.timer_shijo = setInterval(function(){
          countNum++
          switch(true){
            case countNum < 6:
              movNum1 += 4
              break
            case countNum > 12 && countNum < 18:
              movNum1 -= 4
              break
            case countNum > 25 && countNum < 33:
              movNum2 -= 3
              if(countNum === 32){
                _$shijo3.show()
              }
              break
            case countNum > 40 && countNum < 48:
              movNum2 += 3
              if(_$shijo3.is(':visible')){
                _$shijo3.hide()
              }
              break
            case countNum >= 49 && countNum < 52:
              countNum = 0
              movNum1 = 0
              movNum2 = 0
          }
          _$shijo1.css({
            transform: 'translateX(' + movNum1 * -1 + 'vw)'
          })
          _$shijo2.css({
            transform: 'translateX(' + movNum2 * -1 + 'vw)'
          })
        }.bind(this), 300)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #top {
    background: #000;
    padding-bottom: toVW(75);

    .about {
      background-position: top left, bottom left, top left, top toVW(10) right 0;
      background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
      background-size: toVW(20) auto;
      margin-bottom: toVW(144);
      padding: toVW(140) toVW(20) toVW(135);

      h2 {
        width: toVW(520);
        margin: 0 auto toVW(59);
      }

      .ar1 {
        width: toVW(477);
        margin: 0 auto toVW(136);
      }

      .ar2 {
        margin: 0 auto toVW(136);

        h3 {
          width: toVW(450);
          margin: 0 auto toVW(43);
        }
        .chara {
          width: toVW(212);
          margin: 0 auto toVW(55);
        }
        .txt {
          width: toVW(578);
          margin: 0 auto;
        }
      }

      .ar3 {
        h3 {
          width: toVW(352);
          margin: 0 auto toVW(50);
        }
        .chara {
          position: relative;
          margin: 0 auto toVW(56);
          padding: toVW(22) 0 0;
          overflow: hidden;

          .chara1 {
            width: toVW(215);
            margin: 0 auto 0 toVW(223);
          }
          .chara2 {
            width: toVW(176);
            position: absolute;
            top: 0;
            right: toVW(-176);
          }
        }
        .txt {
          width: toVW(578);
          margin: 0 auto;
        }
      }
    }

    .list {
      .lv {
        margin-bottom: toVW(80);

        h3 {
          margin: 0 auto toVW(40);
        }
        ul {
          display: flex;
          flex-flow: row wrap;
          justify-content: center;

          li {
            width: toVW(322);
            flex-shrink: 0;
            position: relative;

            &:nth-child(even) {
              margin-left: toVW(26);
            }

            &:nth-child(n+3) {
              margin-top: toVW(26);
            }

            p {
              font-size: toVW(30);
              text-align: center;
              margin-top: toVW(24);
            }

            &.clear {
              &::after {
                content: "CLEAR";
                color: $COLOR_PINK01;
                font-size: toVW(28);
                text-align: center;
                letter-spacing: .12em;
                width: 100%;
                position: absolute;
                top: toVW(387)
              }
            }
          }
        }
      }
    }

    .select {
      padding: toVW(13) 0 0;
      
      h2 {
        width: toVW(710);
        margin: 0 auto toVW(40);
      }
    }

    .trial {
      .lv {
        &:nth-of-type(7) {
          margin-bottom: toVW(120);
        }
      }
      .chara {
        width: toVW(253);
        margin: 0 auto toVW(35);
      }
      h2 {
        width: toVW(710);
        margin: 0 auto toVW(40);
      }
    }

    .sns {
      .chara {
        width: 100%;
        height: toVW(262);
        margin: 0 auto toVW(42);
        position: relative;
        overflow: hidden;

        .img {
          width: toVW(330);
          position: absolute;
          top: 0;
          right: toVW(-330);
        }
      }
      h2 {
        width: toVW(710);
        margin: 0 auto toVW(40);
      }
      ul {
        display: flex;
        justify-content: center;

        li {
          width: toVW(143);
          margin-left: toVW(40);
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }

    .secret {
      height: toVW(490);
      position: relative;
      overflow: hidden;

      .chara1 {
        width: toVW(187);
        height: auto;
        position: absolute;
        top: toVW(130);
        right: toVW(-187);
      }

      .chara2 {
        width: toVW(207);
        height: auto;
        position: absolute;
        top: toVW(130);
        left: toVW(-207);
      }

      .chara3 {
        width: toVW(84);
        height: auto;
        position: absolute;
        top: toVW(350);
        left: toVW(100);
        display: none;
      }
    }

    #comic {
      margin: 0 auto toVW(145);

      h2 {
        width: toVW(710);
        margin: 0 auto toVW(40);
      }

      .img {
        width: toVW(509);
        margin: 0 auto toVW(46);
      }

      .txt {
        width: toVW(504);
        margin: 0 auto;
      }

    }

    .hr_arw {
      background-repeat: repeat-x;
      background-size: toVW(123) auto;
      width: toVW(615);
      height: toVW(72);
      margin: 0 auto toVW(160);
    }

    .copyright {
      color: #888;
      font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", "sans-serif";
      font-size: toVW(18);
      text-align: center;
    }
  }

  @media screen and (orientation: landscape) {
    #top {
      .mv {
        height: 176.5vw;
      }
    }
  }
</style>